export const cilExitToApp = ["24 24","<path d='M22.125 0.75h-20.25c-0.621 0.001-1.124 0.504-1.125 1.125v7.5h1.5v-7.125h19.5v19.5h-19.5v-7.5h-1.5v7.875c0.001 0.621 0.504 1.124 1.125 1.125h20.25c0.621-0.001 1.124-0.504 1.125-1.125v-20.25c-0.001-0.621-0.504-1.124-1.125-1.125h-0z'></path><path d='M9.815 17.030l1.061 1.061 6.31-6.31-6.31-6.31-1.061 1.061 4.5 4.5h-13.564v1.5h13.564l-4.5 4.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-exit-to-app.js
// module id = null
// module chunks = 